import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../redux/actions/auth";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

// Validation schema
const schema = yup.object({
  new_password: yup
    .string()
    .required("New password is required")
    .min(6, "Minimum 6 characters"),
  confirm_password: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("new_password")], "Passwords must match"),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const { token } = useParams();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: {
      new_password: "",
      confirm_password: "",
    },
  });

  const onSubmit = async (data) => {
    console.log("New Password:", data.new_password);

    const payload = {
      token,
      password: data.new_password,
    };

    try {
      const response = await dispatch(resetPassword(payload)).unwrap();
      toast.success(response?.message || "Account created successfully!");
      reset();
      navigate("/");
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error(error?.message || "Something went wrong. Please try again.");
    } finally {
    }
  };

  const renderEyeIcon = (isVisible) =>
    isVisible ? (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 5C7 5 2.73 8.11 1 12C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 12C21.27 8.11 17 5 12 5Z"
          stroke="#7c8ba0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="3" stroke="#7c8ba0" strokeWidth="2" />
      </svg>
    ) : (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M17.94 17.94C16.23 19.24 14.21 20 12 20C7 20 2.73 16.89 1 13C1.63 11.61 2.62 10.36 3.88 9.32M9.9 4.24C10.58 4.08 11.28 4 12 4C17 4 21.27 7.11 23 11C22.37 12.39 21.38 13.64 20.12 14.68"
          stroke="#7c8ba0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="2"
          y1="2"
          x2="22"
          y2="22"
          stroke="#7c8ba0"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );

  return (
    <section className="auth-page">
      <Container>
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="reset-pasd-box">
              <h2>Reset Password</h2>
              <p>Enter your new password below.</p>

              <Form
                onSubmit={handleSubmit(onSubmit)}
                className="commn-modal-signin p-0"
              >
                <Form.Group className="mb-3 add-eye-icon">
                  <Form.Control
                    type={showPasswordNew ? "text" : "password"}
                    placeholder="New Password"
                    {...register("new_password")}
                  />
                  <span onClick={() => setShowPasswordNew(!showPasswordNew)}>
                    {renderEyeIcon(showPasswordNew)}
                  </span>
                </Form.Group>
                {errors.new_password && (
                  <p className="error-text">{errors.new_password.message}</p>
                )}

                <Form.Group className="mb-3 add-eye-icon">
                  <Form.Control
                    type={showPasswordConfirm ? "text" : "password"}
                    placeholder="Confirm New Password"
                    {...register("confirm_password")}
                  />
                  <span
                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                  >
                    {renderEyeIcon(showPasswordConfirm)}
                  </span>
                </Form.Group>
                {errors.confirm_password && (
                  <p className="error-text">
                    {errors.confirm_password.message}
                  </p>
                )}

                <button
                  type="submit"
                  className="d-block mx-auto mt-5"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Reset Password"}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ResetPassword;
